enum DocumentTypeEnum {
  csv = 'csv',
  kml = 'kml',
  xml = 'xml',
}

export default DocumentTypeEnum
